import React, { createContext } from 'react';
import type { AudiencesData } from '../../../templates/homepage/homepage-helper';

export const HeaderContext = createContext<{
  isSticky: boolean;
  setIsSticky: React.Dispatch<React.SetStateAction<boolean>>;
  isAllCategoriesNavigationOpen: boolean;
  setIsAllCategoriesNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFeaturedNavigationOpen: boolean;
  setIsFeaturedNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isSearchOpen: boolean;
  setIsSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isClearSearch: boolean;
  setIsClearSearch: React.Dispatch<React.SetStateAction<boolean>>;
  isAudienceLoadedFromSegment: boolean;
  audiencesDataFromSegment?: AudiencesData;
  audienceOverRideForPlayground?: AudiencesData['type'];
}>({
  isSticky: false,
  setIsSticky: () => { },
  isAllCategoriesNavigationOpen: false,
  setIsAllCategoriesNavigationOpen: () => { },
  isFeaturedNavigationOpen: false,
  setIsFeaturedNavigationOpen: () => { },
  isSearchOpen: false,
  setIsSearchOpen: () => { },
  isClearSearch: false,
  setIsClearSearch: () => { },
  isAudienceLoadedFromSegment: false,
  audiencesDataFromSegment: { type: null },
  audienceOverRideForPlayground: null,
});
